import $ from 'jquery';
import _ from 'underscore';
import { $body, $window, isMobile, jqOffOn } from 'util/global';
import * as latex from 'util/latex';
import pager from 'util/pager';
import { CustomSelectbox } from 'util/ui';
import * as urls from 'util/urls';
import contentModal from 'app/content_modal';
import 'bootstrap-datepicker';
import 'util/popstate';

const PORTAL_MAIN_CARD_ITEM_COUNT = isMobile ? 5 : 15;

// The object we are going to export
var NewsFeed = {};
var vkey = window.vkey || {};

// is there a better way to deal with empty subscription
// components?
const cleanEmptySubscriptions = () => {
  $('.nf-feed-subscription').each(function () {
    var $this = $(this);
    if ($this.children().length === 0) {
      $this.remove();
    }
  });
};

// Stuff for drilling down through categories starting at Topic to pick a Quiz
// --------------------------------------------------

var field_name_to_next_field_name = {
  topic: 'sub_topic',
  sub_topic: 'chapter',
  chapter: 'recommended_concept_quiz',
};

var categoryOptionsCache = {};

/**
 * Populate categoryOptionsCache object with lists of objects for each possible option.
 * @param {String} next_field_name - The field name of the next category to be loaded
 * @param {String} [this_value] - the numerical id selected for current category
 * @param {String} [previous_value] - the numerical id selected for the previous category
 * Note, exactly one of this_value and previous_value are required, unless the
 * next_field_name is "sub_topic" in which case either "this_value" or neither are allowed.
 * @see brilliant/assessment/views/categorization.py:get_categorization_options()
 */
var load_next_category_options = function (next_field_name, this_value, previous_value, callback) {
  callback = callback || _.noop;
  var value_args = this_value + '-' + previous_value;
  if (
    next_field_name !== undefined &&
    categoryOptionsCache['load_action_' + next_field_name] !== value_args
  ) {
    categoryOptionsCache['load_action_' + next_field_name] = value_args;
    var post_data = {
      next_category_type: next_field_name,
      current_selected_category_id: this_value,
      previous_selected_category_id: previous_value,
    };

    const opts = {
      url: '/assessment/get_categorization_options/',
      type: 'POST',
      data: JSON.stringify(post_data),
      headers: {
        'Content-type': 'application/json',
      },
    };

    $.ajax(opts).done(function (response) {
      categoryOptionsCache[next_field_name] = response;
      callback();
    });
  } else {
    callback();
  }
};

/**
 * Update a fancy custom selectbox with new options
 * @param {JQuery} $container - Container that contains the selectbox
 * @param {Array} options - contains sub-arrays of length 2 [option_value, option_name]
 * Feel free to move/reuse this, I tried to make it as generic as possible
 */
var initialize_ui_selectbox = function ($container, options) {
  var custom_template = _.template($('#custom_select_options_tmpl').text()),
    custom_menu_options = custom_template({ options: options }),
    $dropdown = $container.find('ul.dropdown-menu'),
    select_template = _.template($('#html_select_options_tmpl').text()),
    select_menu_options = select_template({ options: options }),
    $select = $container.find('select'),
    current_value = $select.val(),
    $selected_option_text = $container.find('.dropdown-menu a').find('span').first();

  $selected_option_text.html('...');
  $dropdown.html(custom_menu_options);
  $select.html(select_menu_options);
  CustomSelectbox($container);

  // if there's a value (like when auto-populated by GET params), select the correct option
  if (current_value) {
    // setTimeout to make sure CustomSelectbox is ready
    setTimeout(function () {
      $dropdown.find('[data-opt-value="' + current_value + '"]').click();
    }, 50);
  }
};

/**
 * If we have a list of options for the field type in question for the value
 * that was input at the previous step (for example if there are subtopics
 * for topic 10 aka algebra) this will set up the dropdowns for them and
 * also initialize an event handler and preload the lists for the next
 * category if applicable.
 * @param {JQuery} $container - Container that contains the selectbox
 * @param {String} field_name - The field name of the category to be loaded
 * @param {String} previous_value - the numerical id selected for previous category
 */
var init_category_options = function ($container, field_name, previous_value, callback) {
  callback = callback || _.noop;
  if (
    categoryOptionsCache[field_name] === undefined ||
    categoryOptionsCache[field_name][previous_value] === undefined
  ) {
    callback(false);
    return;
  }

  load_next_category_options(
    field_name_to_next_field_name[field_name],
    '',
    previous_value,
    function () {
      var options = categoryOptionsCache[field_name][previous_value],
        $select = $container.find('select'),
        $div_dropdown = $container.find('div.dropdown');
      initialize_ui_selectbox($container, options);

      jqOffOn($select, 'change', () => {
        handle_category_select($div_dropdown, field_name, $select.val());
      });
      callback(true);
    },
  );
};

/**
 * Loads the category options in the next field, hides the current one and unhides the next.
 * @param {JQuery} $element - Container that contains the selectbox that was just changed
 * @param {String} field_name - The field name of the category that changed
 * @param {String} value - the numerical id that was just selected
 */
var handle_category_select = function ($element, field_name, value) {
  var $this_container = $element.parent('div.field'),
    next_field_name = field_name_to_next_field_name[field_name],
    $next_container = $this_container.parent().find('div.field-' + next_field_name);
  if (value && $next_container.length > 0) {
    init_category_options($next_container, next_field_name, value, function (result) {
      if (result) {
        if ($next_container.data('is-reloading') === true) {
          $next_container.data('is-reloading', false);
        } else {
          $this_container.slideUp();
          $next_container.find('a.back_link').show();
          $next_container.slideDown(400, function () {
            $(this).css('overflow', 'visible');
          });
        }
      }
    });
  }
};

/**
 * link for going backwards in the categorization process.
 * @class
 */
NewsFeed.CategorizationNavBack = (function () {
  var current_field, next_field;
  /**
   * @constructor
   * @param {JQuery} $element
   */
  function CategorizationNavBack($element) {
    var $this_container = $element.parents('div.field');
    var $prev_container = $this_container.prev();
    $element.on('click', function () {
      $this_container.slideUp();
      $prev_container.slideDown(400, function () {
        $(this).css('overflow', 'visible');
      });
    });
  }
  return CategorizationNavBack;
})();

/**
 * Selectbox for topic selecting.
 * @class
 */
NewsFeed.TopicSelector = (function () {
  var $select, data;

  /**
   * @constructor
   * @param {JQuery} $element
   */
  function TopicSelector($element) {
    $select = $element.find('select');
    data = $element.data();
    NewsFeed.selectedTopic = null;

    const changeTopicSelector = () => {
      NewsFeed.selectedTopic = parseInt($select.val(), 10);
      if (data.filter_categories !== undefined) {
        handle_category_select($element, 'topic', $select.val());
      }
    };

    jqOffOn($select, 'change', changeTopicSelector);
    if (data.filter_categories !== undefined) {
      load_next_category_options('sub_topic', '', '', changeTopicSelector);
    }
  }

  return TopicSelector;
})();

/**
 * This function is related to staff toolbox which can appear below every feed items
 * @param {JQuery} [$root] Feed item jQuery element (BODY by default)
 */
const bindNewsfeedItemsEventHandlers = ($root = $body) => {
  var $feeditems = $root.is('.nf-feed-item') ? $root : $root.find('.nf-feed-item');
  $feeditems.each(function () {
    var $feed_item = $(this);
    $feed_item.find('.staff-tools-toggle').on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      $feed_item.find('.staff-tools').toggle();
    });
    $feed_item.find('.mini-profile').on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var url = $(this).data('url');
      if (url) window.location.href = url;
    });
  });
};

/**
 * Setup datepicker widget for the started problems page. Uses bootstrap-datepicker.
 * @param {JQuery} $container
 */
NewsFeed.datepicker = function ($container) {
  var wasCleared = false;
  var monthView = 0;
  var defaultData = {
    maxViewMode: monthView,
    minViewMode: 'days',
    startView: monthView,
    clearBtn: window.location.search.search(/[\?|&]before_date=/) >= 0,
    templates: {
      leftArrow: '<span class="arrow left"></span>',
      rightArrow: '<span class="arrow right"></span>',
    },
  };

  var routeToLocationWithDate = function (d) {
    var params = urls.getParamsObject();
    if (d !== null) {
      params.before_date = d.getTime() / 1000;
    } else if (params.before_date) {
      delete params.before_date;
    }
    $container.siblings('.dropdown-toggle').dropdown('toggle');
    window.location = urls.appendGetParams(window.location.pathname, params);
  };

  $container.datepicker(_.extend({}, defaultData, $container.data()));

  $container.on('changeDate', function (e) {
    if (!wasCleared) {
      routeToLocationWithDate(e.date);
    }
  });

  // override the default clear button behaviour (it doesn't fire the `clearDate` event)
  $container.find('.clear').on('click', function (e) {
    wasCleared = true;
    routeToLocationWithDate(null);
  });
};

/** @param {JQuery} $container */
NewsFeed.feed = $container => {
  pager.init();
  if ($container.attr('id') !== 'wiki-main') {
    pager.autopagination();
  }
  contentModal.feeditem_modal();
  cleanEmptySubscriptions();
  latex.scaleSVG($('.latexprocessor-block'));
  bindNewsfeedItemsEventHandlers();
};

// vkeys
// --------------------------------------------------

var feed_container_handler = function (action, actionKey) {
  const $root = vkey.handle(action, actionKey);
  $('.nf-next-container.loading').removeClass('loading').addClass('loaded');
  latex.updateMathjax($root);

  contentModal.feeditem_modal($root);

  pager.reset_autopagination_point();
  pager.needs_additional_pagination($root);

  latex.scaleSVG($('.latexprocessor-block'));
  latex.checkOverflow($root);

  // fire an aritificial scroll event to make sure the page is full
  $window.trigger('scroll');

  // preload first set item
  if (contentModal.open_modal_is_set) {
    contentModal.preloadFirstItem($newsfeed_modal_set_content);
  }

  bindNewsfeedItemsEventHandlers($root);
};

vkey.problems_started_problems_container = feed_container_handler;
vkey.profile_forlater_container = feed_container_handler;

const feedItemHandler = (action, actionKey) => {
  const $root = vkey.handle(action, actionKey);
  latex.updateMathjax($root);
  contentModal.feeditem_modal($root);
  latex.scaleSVG($('.latexprocessor-block'));
  bindNewsfeedItemsEventHandlers($root.parent());
};

vkey.problems_started_solvable_component = feedItemHandler;

module.exports = NewsFeed;
